
import axiosInstance from "../../interceptor";

const CommunicationApi = {
  sendMessage: (allPassengers: boolean, accountId: string, toAccountId: string, title: string, text: string) => axiosInstance.post('/communication/message', { allPassengers: allPassengers, accountId: accountId, toAccountId: toAccountId, title: title, text: text }),
};

export default CommunicationApi;